import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=378b5c0a&"
import script from "./MenuEdit.vue?vue&type=script&lang=js&"
export * from "./MenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378b5c0a')) {
      api.createRecord('378b5c0a', component.options)
    } else {
      api.reload('378b5c0a', component.options)
    }
    module.hot.accept("./MenuEdit.vue?vue&type=template&id=378b5c0a&", function () {
      api.rerender('378b5c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Resource/MenuEdit.vue"
export default component.exports